import { useHashScroll } from "@/hooks/useHashScroll";
import { SiteNav } from "@/components/home/SiteNav";
import { KidsHero } from "@/components/home/KidsHero";
import { AdventureSection } from "@/components/home/AdventureSection";
import { GrownUpsShowcase } from "@/components/home/GrownUpsShowcase";
import { FreeTools } from "@/components/home/FreeTools";
import { CourseComingSoon } from "@/components/home/CourseComingSoon";
import { AboutSection } from "@/components/home/AboutSection";
import { NewsletterSection } from "@/components/home/NewsletterSection";
import { SiteFooter } from "@/components/home/SiteFooter";

const LandingPage = () => {
  useHashScroll();

  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <SiteNav />
      <main>
        <KidsHero />
        <AdventureSection />
        <GrownUpsShowcase />
        <FreeTools />
        <CourseComingSoon />
        <AboutSection />
        <NewsletterSection />
      </main>
      <SiteFooter />
    </div>
  );
};

export default LandingPage;
